import { Helmet } from 'react-helmet';
import CorporateBanner from '../../../../components/common/form/CorporateBanner';
import Canonical from '../../../../components/common/layout/Canonical';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { dataActions } from '../../../../shared/store/data-Slice';
import { useDispatch } from 'react-redux';
import { LinkArr } from '../../../../components/common/svg/AllSvg';
import { useSitemap } from '../../../../shared/hooks/use-sitemap';

const OtherMetros = () => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    useSitemap();
    const data: any[] = [
        { name: t("corporate.content_pages.other_metros.metros.delhi_metro"), url: "https://delhimetrorail.com/" },
        { name: t("corporate.content_pages.other_metros.metros.jaipur_metro"), url: "https://www.jaipurmetrorail.in/" },
        { name: t("corporate.content_pages.other_metros.metros.kochi_metro"), url: "https://kochimetro.org/" },
        { name: t("corporate.content_pages.other_metros.metros.hyderabad_metro"), url: "http://www.hmr.gov.in/" },
        { name: t("corporate.content_pages.other_metros.metros.chennai_metro"), url: "http://chennaimetrorail.gov.in/" },
        { name: t("corporate.content_pages.other_metros.metros.nagpur_metro"), url: "https://www.metrorailnagpur.com/landing.aspx" }
    ]

    const handleLink = (item: any) => {
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(item));
    }

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.other_metros.title")}</title>
                <meta name="description" content={t("seo_friendly.other_metros.desc")} />
            </Helmet>
            <div className='bg-white dark:bg-bgDarkDull'>
                <CorporateBanner title={t("corporate.content_pages.other_metros.title")} root1={t("corporate.content_pages.photo_gallery.home")} root2={t("corporate.content_pages.other_metros.title")} />
                <div id="home" className="w-full container pt-[30px] xsm:pt-[40px] xlx:pt-[60px] pb-[60px] xsm:pb-[70px] lg:pb-[90px] xlx:pb-[110px] mms:!px-[30px] flex flex-col gap-[15px]">
                    <h5 className='text-blackDark dark:text-textBlackDark font-bold uppercase'>{t("corporate.content_pages.other_metros.desc")}</h5>

                    <div className='flex flex-col w-full md:max-w-[800px] border border-[#E7E8EC] dark:border-[#454545]'>
                        {Array.isArray(data) && data?.map((item: any, index: number) => (
                            <div className={`${(index + 1 === data?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full py-[15px] px-[30px]`} key={index}>
                                <Link to={item?.url} onClick={(e) => { handleLink(item?.url); e.preventDefault(); }} className="text-blackDull dark:text-textBlackDull font-medium text-base flex items-center gap-[10px] hover:underline focus:underline w-fit">{item?.name} <LinkArr className="fill-blackDull dark:fill-white min-w-[10px] w-[10px] h-[10px]" /></Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default OtherMetros;